"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _constructedForm2 = require("./constructed-form.props/constructed-form.defaultProps");
var _constructedForm3 = require("./constructed-form.props/constructed-form.propTypes");
var _p;
/**
 * ## CalendarPanel - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
// eslint-disable-next-line
var getDaysInMonth = function getDaysInMonth(month, year) {
  var currentYear = Number(year);
  var returnValue = 0;
  var oddDays = [0, 2, 4, 6, 7, 9, 11]; //eslint-disable-line

  if (oddDays.indexOf(month) > -1) {
    returnValue = 31; // eslint-disable-line
    // eslint-disable-next-line
  } else if (month === 3 || month === 5 || month === 8 || month === 10) {
    returnValue = 30; // eslint-disable-line
  } else if (month === 1) {
    // eslint-disable-next-line
    if (currentYear % 4 === 0 && currentYear % 100 !== 0 || currentYear % 4 === 0 && currentYear % 100 === 0 && currentYear % 400 === 0) {
      returnValue = 29; // eslint-disable-line
    } else {
      returnValue = 28; // eslint-disable-line
    }
  }
  return returnValue;
};
var getDateArray = function getDateArray(month, year) {
  var arr = [];
  var dt = new Date();
  var endDate = new Date();
  dt.setFullYear(year);
  dt.setMonth(month);
  dt.setDate(1);
  endDate.setFullYear(year);
  endDate.setMonth(month);
  endDate.setDate(getDaysInMonth(month, year));
  while (dt <= endDate) {
    arr.push(new Date(dt));
    dt.setDate(dt.getDate() + 1);
  }
  return arr;
};
var getShiftedDay = function getShiftedDay(date, weekStartDay) {
  var adjustedDayIndex = date.getUTCDay();
  if (weekStartDay > 0) {
    adjustedDayIndex = adjustedDayIndex - weekStartDay >= 0 ? adjustedDayIndex - weekStartDay : 7 + (adjustedDayIndex - weekStartDay); // eslint-disable-line
  }
  return adjustedDayIndex;
};
var renderYearsList = function renderYearsList() {
  var currentYear = new Date().getFullYear();
  var years = [];
  var rangeYear = 100;
  var startYear = currentYear - rangeYear;
  while (startYear <= currentYear) {
    years.push(startYear += 1);
  }
  return years;
};
var isInFuture = function isInFuture(givenDate) {
  return givenDate.setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0);
};
var defaultClickDateButtonHandler = function clickDateButtonHandler(e) {
  e.preventDefault();
};
var defaultFocusDateButtonHandler = function focusDateButtonHandler(e) {
  e.preventDefault();
};
var NewCalendarPanel = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(NewCalendarPanel, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  NewCalendarPanel.resourceType = function resourceType() {
    return 'TextField_1_0_0';
  };
  NewCalendarPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var _props$data = props.data,
      dayNames = _props$data.dayNames,
      weekStartDay = _props$data.weekStartDay,
      month = _props$data.month,
      year = _props$data.year;
    var dayMap = dayNames.map(function (dayName, i) {
      var updatedDayName = dayNames[i + weekStartDay];
      if (updatedDayName === undefined) {
        updatedDayName = dayNames[i + (weekStartDay - 7)]; // eslint-disable-line
      }
      return updatedDayName;
    });
    var calendarArray = getDateArray(month, year);
    var calendarStartDay = getShiftedDay(calendarArray[0], weekStartDay);
    var calendarEndDay = getShiftedDay(calendarArray[calendarArray.length - 1], weekStartDay);
    for (var i = 0; i < calendarStartDay; i += 1) {
      calendarArray.unshift(null);
    }
    // eslint-disable-next-line
    for (var j = 0; j < 6 - calendarEndDay; j += 1) {
      calendarArray.push(null);
    }
    return {
      dayMap: dayMap,
      calendarArray: calendarArray
    };
  };
  function NewCalendarPanel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var clickDateButtonHandler = props.clickDateButtonHandler,
      focusDateButtonHandler = props.focusDateButtonHandler;
    var _props$data2 = props.data,
      dayNames = _props$data2.dayNames,
      weekStartDay = _props$data2.weekStartDay,
      month = _props$data2.month,
      year = _props$data2.year;
    var dayMap = dayNames.map(function (dayName, i) {
      var updatedDayName = dayNames[i + weekStartDay];
      if (updatedDayName === undefined) {
        updatedDayName = dayNames[i + (weekStartDay - 7)]; // eslint-disable-line
      }
      return updatedDayName;
    });
    var calendarArray = getDateArray(month, year);
    var calendarStartDay = getShiftedDay(calendarArray[0], weekStartDay);
    var calendarEndDay = getShiftedDay(calendarArray[calendarArray.length - 1], weekStartDay);
    for (var i = 0; i < calendarStartDay; i += 1) {
      calendarArray.unshift(null);
    }
    // eslint-disable-next-line
    for (var j = 0; j < 6 - calendarEndDay; j += 1) {
      calendarArray.push(null);
    }
    _this.state = {
      dayMap: dayMap,
      calendarArray: calendarArray,
      clickDateButtonHandler: clickDateButtonHandler || defaultClickDateButtonHandler,
      focusDateButtonHandler: focusDateButtonHandler || defaultFocusDateButtonHandler
    };
    return _this;
  }
  var _proto = NewCalendarPanel.prototype;
  _proto.renderCalendarPanel = function renderCalendarPanel() {
    var _this$props = this.props,
      theme = _this$props.theme,
      data = _this$props.data;
    var activeDate = data.activeDate,
      browseDate = data.browseDate;
    var _this$state = this.state,
      dayMap = _this$state.dayMap,
      calendarArray = _this$state.calendarArray,
      clickDateButtonHandler = _this$state.clickDateButtonHandler,
      focusDateButtonHandler = _this$state.focusDateButtonHandler;
    var weekCount = 0;
    var calendarWeeks = [];
    for (var i = 0; i < calendarArray.length; i += 1) {
      // eslint-disable-next-line
      if (i > 0 && i % 7 === 0) {
        weekCount += 1;
      }
      if (calendarWeeks[weekCount] === undefined) {
        calendarWeeks[weekCount] = [];
      }
      calendarWeeks[weekCount].push(calendarArray[i]);
    }
    return /*#__PURE__*/_react["default"].createElement("table", {
      className: _constructedForm["default"].calendar
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, dayMap.map(function (adjustedDayName) {
      return /*#__PURE__*/_react["default"].createElement("th", {
        className: _constructedForm["default"].dateHeader + " " + theme.BodyCopyBold,
        key: adjustedDayName
      }, adjustedDayName);
    }))), /*#__PURE__*/_react["default"].createElement("tbody", null, calendarWeeks.map(function (weekArray) {
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: "week_" + weekArray
      }, weekArray.map(function (date) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "day_" + date
        }, date === null ? _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null)) : /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: _constructedForm["default"].dateBtn + " " + theme.BodyCopyBold + " " + (activeDate.getDate() === date.getDate() && activeDate.getFullYear() === date.getFullYear() && activeDate.getMonth() === date.getMonth() ? _constructedForm["default"].isActive : '') + " " + (!isInFuture(date) && browseDate.getDate() === date.getDate() && browseDate.getFullYear() === date.getFullYear() && browseDate.getMonth() === date.getMonth() ? _constructedForm["default"].isBrowsed : '') + " " + (isInFuture(date) ? _constructedForm["default"].disabledDate : ''),
          onClick: isInFuture(date) ? function () {
            return undefined;
          } : function (e) {
            clickDateButtonHandler(e, date);
          },
          onFocus: function onFocus(e) {
            return focusDateButtonHandler(e, date);
          }
        }, date.getDate()));
      }));
    })));
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      _this$props2$data = _this$props2.data,
      browseDate = _this$props2$data.browseDate,
      month = _this$props2$data.month,
      year = _this$props2$data.year,
      monthSelectionHandler = _this$props2.monthSelectionHandler,
      yearSelectionHandler = _this$props2.yearSelectionHandler,
      monthNames = _this$props2.monthNames,
      theme = _this$props2.theme;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])([_constructedForm["default"].calendarPanel])
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _clsx["default"])([theme.HeaderSm, _constructedForm["default"].calendarTitle, _constructedForm["default"].newCalendarTitle])
    }, /*#__PURE__*/_react["default"].createElement("select", {
      className: (0, _clsx["default"])([theme.customSelect, _constructedForm["default"].newDatePickerMonthDropdown]),
      value: month,
      onChange: function onChange(_ref) {
        var value = _ref.target.value;
        monthSelectionHandler(value, browseDate);
      }
    }, monthNames.map(function (option, index) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option,
        value: index
      }, option);
    })), /*#__PURE__*/_react["default"].createElement("select", {
      className: (0, _clsx["default"])([theme.customSelect, _constructedForm["default"].newDatePickerYearDropdown]),
      value: year,
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        yearSelectionHandler(value, browseDate);
      }
    }, renderYearsList().map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option,
        value: option
      }, option);
    }))), this.renderCalendarPanel());
  };
  return NewCalendarPanel;
}(_react["default"].Component);
exports["default"] = NewCalendarPanel;
NewCalendarPanel.displayName = 'NewCalendarPanel';
NewCalendarPanel.defaultProps = {
  data: _constructedForm2.PAST_DATE_PICKER_DEFAULT_PROPS.formComponents[0],
  // eslint-disable-line
  theme: {}
};